export const SITE_MANAGEMENT_FLAGS = {};
